module.exports = __webpack_public_path__ + "img/pathers_bg.25e9f3b1.png";